import styled from "styled-components";
import LogoImageClearScoreDesktop from "@theme/assets/clear-score-linear.svg";
import React from "react";

const ClearScoreLogoWrapper = styled.div`
  width: 150px;
  margin-top: 6px;
  display: block;
`;

export const ClearScoreLogo = () => (
  <ClearScoreLogoWrapper>
    <img src={LogoImageClearScoreDesktop} alt="logo" />
  </ClearScoreLogoWrapper>
);